module.exports = __WEBPACK_EXTERNAL_MODULE_70__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react-addons-transition-group","commonjs2":"react-addons-transition-group","amd":"react-addons-transition-group","root":["React","addons","TransitionGroup"]}
 ** module id = 70
 ** module chunks = 0
 **/